// extracted by mini-css-extract-plugin
export default {"header":"SyllabusHeader_header__k+wSn","title":"SyllabusHeader_title__XE+2a","muted":"SyllabusHeader_muted__fmOVK","sylSelect":"SyllabusHeader_sylSelect__7i0FE"};